export default __webpack_public_path__ + "static/media/King_of_spades.9c329334.svg";